<template>
  <div class="left padding">
    <h2 class="titles">
      {{ this.$t("expedientes.titulo2") }}
    </h2>
    <SelectButton
      class="optionsContainer"
      v-model="showDrafts"
      optionLabel="label"
      optionValue="value"
      :options="selectOptions"
    />

    <Expedientes v-if="showDrafts === 'expedientes'" />
    <Reclamaciones
      :idLegalCliente="idLegalCliente"
      :idLegalUsuario="idLegalUsuario"
      v-if="showDrafts === 'reclamaciones'"
    />
    <Borradores v-if="showDrafts === 'borradores'" />
  </div>
</template>

<script>
import { GET_USUARIO_BY_UUID } from "@/graphQLQueries/UsuarioQueries";
import Borradores from "./Borradores";
import Expedientes from "./Expedientes";
import Reclamaciones from "./Reclamaciones";
import RoutesMixin from "@/utils/routes";
import DatesMixin from "@/utils/dates";

export default {
  name: "ExpedientesMain",
  mixins: [DatesMixin, RoutesMixin],
  props: {},
  components: {
    Borradores,
    Expedientes,
    Reclamaciones,
  },
  data() {
    return {
      showDrafts: "expedientes",
      usuario: {},
      idLegalCliente: "",
      idLegalUsuario: "",
      selectOptions: [
        { label: "Expedientes", value: "expedientes" },
        { label: "Reclamaciones", value: "reclamaciones" },
        { label: "Borradores", value: "borradores" },
      ],
    };
  },
  apollo: {
    usuario: {
      query: GET_USUARIO_BY_UUID,
      variables() {
        return {
          uuidUsuario: this.$store.state.profile.uuid,
          idioma: this.$i18n.locale,
        };
      },
      fetchPolicy: "no-cache",
      update(data) {
        let user = data.getUsuarioUuid;
        if (typeof user !== undefined && user.clienteIdLegal) {
          this.idLegalCliente = user.clienteIdLegal;
          this.idLegalUsuario = user.clienteIdLegal;
        }

        return user;
      },
    },
  },
  watch: {
    showDrafts(newValue, oldValue) {
      if (newValue == null) {
        this.showDrafts = oldValue;
      }
    },
  },
  methods: {},
  created() {
    this.showDrafts = this.$route.params["subTab"] || this.showDrafts;
  },
};
</script>

<style lang="scss">
</style>

<style lang="scss" scoped>
.padding {
  padding: 2%;
}
</style>